import Error404 from "./pages/error/Error404";


export default [{
    path: '/error/404',
    title: '页面不存在',
    component: Error404
}]